import { observer } from 'mobx-react-lite';
import { underscoresToHighlights } from '../../utils/parse-text';
import { Link } from 'react-router-dom';

function OurStoryHeroArea({ data = {}, locale = 'en' }) {
  const backgroundImageUrl = data?.hero_image?.files?.large?.url;

  return (
    <div
      className="relative flex h-[50vh] justify-center bg-cover bg-center bg-no-repeat text-h1 h-screen"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      <div className="mx-4 flex h-full w-full max-w-720px flex-col text-center justify-center md:mx-0">
        <h1
          className="pb-7 text-left text-h2 uppercase text-white md:text-center md:text-headline"
          dangerouslySetInnerHTML={{ __html: underscoresToHighlights(data?.hero_title) }}
        />
        <p className="pb-7 text-left text-small text-white md:text-center md:text-content">{data?.description}</p>
        <div className="flex w-full gap-12 md:w-fit justify-center">
          {data?.buttons?.map(button => (
            <Link
              key={button.key}
              href={button.attributes?.link?.[locale]}
              className="btn align-items-center mt-30 bg-main-product-50 hover-bg-main-product-50 mt-20 mb-20"
            >
              <div>{button.attributes?.title}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default observer(OurStoryHeroArea);
